export const QUICK_START_BASE = 'QUICK_START_BASE'
export const QUICK_START_INFO = 'QUICK_START_INFO'
export const QUICK_START_DOCUMENTS = 'QUICK_START_DOCUMENTS'
export const QUICK_START_CONTRACT = 'QUICK_START_CONTRACT'
